<template lang="pug">
    .medical-organizations-dictionary
        .edit-dictionary__top
            .edit-dictionary__name Медицинские организации
            p Данный справочник служит для указания препаратов таргетной терапии. Доза, единицы измерения и кратность могут быть указаны только в соответствии с приведенными в справочнике значениями. Если поле оставлено пустым (например, не указано значение дозы), то пи заполнении карты пациента можно будет указать любое значение.
        dictionary-default-template(
            action-name="fetchMedicalOrganizations"
            getter-name="medicalOrganizations"
            url-part="medical-organization"
        )
</template>

<script>
import DictionaryDefaultTemplate from '@/components/pages/dictionaries/DictionaryDefaultTemplate';

export default {
    name: 'medical-organizations-dictionary',

    components: {
        DictionaryDefaultTemplate,
    },
};
</script>
